// Team Shell i18n — prefixes `nav.` (layout / command palette) and `dash.` (dashboard / notifications).
// Dashboard strings live in ./shell-dash.js, profile strings in ./shell-profile.js.
const shell = {
  en: {
    "nav.home": "Home",
    "nav.mainNav": "Main navigation",
    "nav.skipToContent": "Skip to content",
    "nav.newRelease": "New release",
    "nav.newSingle": "Single",
    "nav.newSingleDesc": "One track, delivered to all stores",
    "nav.newAlbum": "Album / EP",
    "nav.newAlbumDesc": "Multiple tracks in one release",
    "nav.drafts": "Drafts",
    "nav.draftsDesc": "Continue where you left off",
    "nav.upload": "Upload",
    "nav.menu": "Menu",
    "nav.openMenu": "Open menu",
    "nav.closeMenu": "Close",
    "nav.account": "Account",
    "nav.notifications": "Notifications",
    "nav.notification": "Notification",
    "nav.markAllRead": "Mark all read",
    "nav.noNotifications": "You're all caught up",
    "nav.viewAllNotifications": "View all notifications",
    "nav.search": "Search (Ctrl+K)",
    "nav.searchShort": "Search…",
    "nav.commandTitle": "Command palette",
    "nav.commandDesc": "Search your releases or jump to any page",
    "nav.commandPlaceholder": "Search releases, ISRC, UPC or pages…",
    "nav.searching": "Searching…",
    "nav.noResults": "No results found.",
    "nav.searchError": "Search is unavailable right now",
    "nav.yourReleases": "Your releases",
    "nav.track": "Track",
    "nav.recent": "Recent",
    "nav.kbdNavigate": "navigate",
    "nav.kbdOpen": "open",
    "nav.kbdClose": "close",
    "nav.lightMode": "Light mode",
    "nav.darkMode": "Dark mode",
    "nav.wallet": "Wallet",
    "nav.balance": "Balance",
    "nav.withdrawable": "Withdrawable",
    "nav.badge.verified": "Verified",
    "nav.badge.artist": "Artist",
    "nav.badge.label": "Label",
    "nav.badge.brokeArtist": "Broke Artist",
    "nav.plan.free": "Free",
    "nav.plan.artist": "Artist",
    "nav.plan.pro": "Pro",
    "nav.plan.label": "Label",
    "nav.section.community": "Community",
  },
  tr: {
    "nav.home": "Ana Sayfa",
    "nav.mainNav": "Ana menü",
    "nav.skipToContent": "İçeriğe geç",
    "nav.newRelease": "Yeni Yayın",
    "nav.newSingle": "Single",
    "nav.newSingleDesc": "Tek parça, tüm mağazalara dağıtım",
    "nav.newAlbum": "Albüm / EP",
    "nav.newAlbumDesc": "Tek yayında birden fazla parça",
    "nav.drafts": "Taslaklar",
    "nav.draftsDesc": "Kaldığın yerden devam et",
    "nav.upload": "Yükle",
    "nav.menu": "Menü",
    "nav.openMenu": "Menüyü aç",
    "nav.closeMenu": "Kapat",
    "nav.account": "Hesap",
    "nav.notifications": "Bildirimler",
    "nav.notification": "Bildirim",
    "nav.markAllRead": "Tümünü okundu say",
    "nav.noNotifications": "Yeni bildirimin yok",
    "nav.viewAllNotifications": "Tüm bildirimleri gör",
    "nav.search": "Ara (Ctrl+K)",
    "nav.searchShort": "Ara…",
    "nav.commandTitle": "Komut paleti",
    "nav.commandDesc": "Yayınlarında ara veya herhangi bir sayfaya git",
    "nav.commandPlaceholder": "Yayın, ISRC, UPC veya sayfa ara…",
    "nav.searching": "Aranıyor…",
    "nav.noResults": "Sonuç bulunamadı.",
    "nav.searchError": "Arama şu anda kullanılamıyor",
    "nav.yourReleases": "Yayınların",
    "nav.track": "Parça",
    "nav.recent": "Son kullanılanlar",
    "nav.kbdNavigate": "gezin",
    "nav.kbdOpen": "aç",
    "nav.kbdClose": "kapat",
    "nav.lightMode": "Açık tema",
    "nav.darkMode": "Koyu tema",
    "nav.wallet": "Cüzdan",
    "nav.balance": "Bakiye",
    "nav.withdrawable": "Çekilebilir",
    "nav.badge.verified": "Doğrulanmış",
    "nav.badge.artist": "Sanatçı",
    "nav.badge.label": "Plak Şirketi",
    "nav.badge.brokeArtist": "Broke Artist",
    "nav.plan.free": "Ücretsiz",
    "nav.plan.artist": "Artist",
    "nav.plan.pro": "Pro",
    "nav.plan.label": "Label",
    "nav.section.community": "Topluluk",
  },
  es: {
    "nav.home": "Inicio",
    "nav.mainNav": "Navegación principal",
    "nav.skipToContent": "Saltar al contenido",
    "nav.newRelease": "Nuevo lanzamiento",
    "nav.newSingle": "Sencillo",
    "nav.newSingleDesc": "Una pista, distribuida a todas las tiendas",
    "nav.newAlbum": "Álbum / EP",
    "nav.newAlbumDesc": "Varias pistas en un lanzamiento",
    "nav.drafts": "Borradores",
    "nav.draftsDesc": "Continúa donde lo dejaste",
    "nav.upload": "Subir",
    "nav.menu": "Menú",
    "nav.openMenu": "Abrir menú",
    "nav.closeMenu": "Cerrar",
    "nav.account": "Cuenta",
    "nav.notifications": "Notificaciones",
    "nav.notification": "Notificación",
    "nav.markAllRead": "Marcar todo como leído",
    "nav.noNotifications": "Estás al día",
    "nav.viewAllNotifications": "Ver todas las notificaciones",
    "nav.search": "Buscar (Ctrl+K)",
    "nav.searchShort": "Buscar…",
    "nav.commandTitle": "Paleta de comandos",
    "nav.commandDesc": "Busca tus lanzamientos o salta a cualquier página",
    "nav.commandPlaceholder": "Busca lanzamientos, ISRC, UPC o páginas…",
    "nav.searching": "Buscando…",
    "nav.noResults": "No se encontraron resultados.",
    "nav.searchError": "La búsqueda no está disponible ahora",
    "nav.yourReleases": "Tus lanzamientos",
    "nav.track": "Pista",
    "nav.recent": "Recientes",
    "nav.kbdNavigate": "navegar",
    "nav.kbdOpen": "abrir",
    "nav.kbdClose": "cerrar",
    "nav.lightMode": "Modo claro",
    "nav.darkMode": "Modo oscuro",
    "nav.wallet": "Billetera",
    "nav.balance": "Saldo",
    "nav.withdrawable": "Retirable",
    "nav.badge.verified": "Verificado",
    "nav.badge.artist": "Artista",
    "nav.badge.label": "Sello",
    "nav.badge.brokeArtist": "Broke Artist",
    "nav.plan.free": "Gratis",
    "nav.plan.artist": "Artist",
    "nav.plan.pro": "Pro",
    "nav.plan.label": "Label",
    "nav.section.community": "Comunidad",
    // Fix low-quality machine translations of existing nav keys
    "nav.section.music": "Música",
    "nav.section.career": "Carrera",
    "nav.bioLink": "Bio Link",
    "nav.canvasStudio": "Canvas Studio",
    "nav.aiMastering": "Masterización IA",
    "nav.aiMatcher": "AI Matcher",
    "nav.playlistExplorer": "Explorador de playlists",
    "nav.mixMastering": "Mezcla y masterización",
  },
};

export default shell;
